<template>
  <b-button variant="warning" @click.stop="voltar()">
    <span><i class="fa fa-history"></i> {{btnTitle}}</span>
  </b-button>
</template>

<script>
export default {
  name: 'BtnVoltar',
  props: {
    btnTitle: {
      type: String,
      default: 'Voltar'
    }
  },

  methods: {
    voltar () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BtnVoltar.vue